'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _layout = require('../../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TenantIcon = function (_React$Component) {
    _inherits(TenantIcon, _React$Component);

    function TenantIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TenantIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TenantIcon.__proto__ || Object.getPrototypeOf(TenantIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (size, color) {
            return _react2.default.createElement(
                'svg',
                { id: 'tenant-insurance', xmlns: 'http://www.w3.org/2000/svg', width: size, height: size, viewBox: '0 0 24 24' },
                _react2.default.createElement('rect', { id: 'Bounding_box', 'data-name': 'Bounding box', width: size, height: size, fill: 'transparent' }),
                _react2.default.createElement(
                    'g',
                    { id: 'Group_14', transform: 'translate(-144.459 -48.005)' },
                    _react2.default.createElement(
                        'g',
                        { id: 'house-user' },
                        _react2.default.createElement('path', { fill: color, id: 'Shape_38', d: 'M164.64,49.493a.49.49,0,0,0-.48-.5H160.8a.49.49,0,0,0-.48.5v.289a1.476,1.476,0,0,0,.332.861l3.822,4.162c.091.1.166.068.166-.069Z' }),
                        _react2.default.createElement('path', { fill: color, id: 'Shape_39', d: 'M168,70.992a.981.981,0,0,0-.96-1H165.6a.49.49,0,0,1-.48-.5v-7.5a.49.49,0,0,1,.48-.5h1.44a.96.96,0,0,0,.883-.607,1.031,1.031,0,0,0-.189-1.084L157.173,48.3a.963.963,0,0,0-1.387,0l-10.56,11.5a1.032,1.032,0,0,0-.19,1.085.96.96,0,0,0,.884.607h1.44a.49.49,0,0,1,.48.5v7.5a.49.49,0,0,1-.48.5h-1.44a1,1,0,0,0,0,2h21.12A.981.981,0,0,0,168,70.992ZM156.48,55.243a2.5,2.5,0,1,1-2.4,2.5A2.452,2.452,0,0,1,156.48,55.243Zm-2.558,11a.61.61,0,0,1,.568.491s.365,1.986.533,2.857a.484.484,0,0,0,.47.4h1.975a.484.484,0,0,0,.469-.4c.169-.871.533-2.857.533-2.857a.61.61,0,0,1,.568-.491h.322a.49.49,0,0,0,.48-.5v-1a3.363,3.363,0,1,0-6.72,0v1a.49.49,0,0,0,.48.5Z', fillRule: 'evenodd' })
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TenantIcon, [{
        key: 'render',
        value: function render() {
            return this.getIcon(this.props.size || 24, this.props.color);
        }
    }]);

    return TenantIcon;
}(_react2.default.Component);

exports.default = TenantIcon;